import { StudyWorklistType, useGetWorklistStudyByIdLazyQuery } from '@eva-pacs/client';

import { useStudyListStore } from '~/src/store';

import { useWorklistQueries } from './useWorklistQueries';
import { useProcessStudyForInsertion } from '../study/useProcessStudyForInsertion';
import { useStudyActions } from '../study/useStudyActions';
import { useRemoveStudy } from '../study/useRemoveStudy';

export const useUpdateStudy = () => {
  const getStudies = useStudyListStore((state) => state.getStudies);
  const { performRemoveStudy } = useStudyActions();
  const { processRemoveStudy } = useRemoveStudy();
  const { getWorklistPositions } = useWorklistQueries();
  const { insertNewStudy } = useProcessStudyForInsertion();
  const [getWorklistStudy] = useGetWorklistStudyByIdLazyQuery({
    fetchPolicy: 'network-only',
    onCompleted: (response) => {
      if (!response.studyWorklist?.results) return;
      const newStudy = response.studyWorklist.results[0];
      if (!newStudy) return;

      acommodateStudy(newStudy.id, newStudy as StudyWorklistType);
    },
  });

  const acommodateStudy = async (studyId: string, newStudy: StudyWorklistType) => {
    const positions = await getWorklistPositions(studyId);
    const studies = getStudies();

    if (!positions) return;
    const nextId = positions?.nextId;
    const prevId = positions?.prevId;

    if (!studies[nextId] && !studies[prevId]) {
      processRemoveStudy(studyId);
      return;
    }

    // We need to remove the current item in the store in order to insert it in where it belongs.
    performRemoveStudy(studyId);

    // Inserting updated study.
    insertNewStudy({ nextId, prevId, newStudy, enableNewStudyAnimation: false });
  };

  const processUpdateWorklistStudy = async (studyId: string) => {
    const studies = getStudies();

    // Only request study information if we are going to update it in the store, if not
    // we are not going to request information because we don't have anything to update.
    if (!studies[studyId]) return;

    getWorklistStudy({
      variables: {
        idsIn: [studyId],
      },
    });
  };

  const processUpdateStudyListStudy = (studyId: string) => {
    const studies = getStudies();

    // Only request study information if we are going to update it in the store, if not
    // we are not going to request information because we don't have anything to update.
    if (!studies[studyId]) return;

    // TODO: add queries for study list.
  };

  return {
    processUpdateWorklistStudy,
    processUpdateStudyListStudy,
  };
};
